export const recognizeReferencePoint = ({
  top,
  left,
  bottom,
  right,
}: {
  top?: number | string;
  left?: number | string;
  bottom?: number | string;
  right?: number | string;
}) => {
  let x = null;
  let y = null;
  if (!(left !== undefined && right !== undefined)) {
    if (left !== undefined) x = 'left';
    if (right !== undefined) x = 'right';
  }
  if (!(top !== undefined && bottom !== undefined)) {
    if (top !== undefined) y = 'top';
    if (bottom !== undefined) y = 'bottom';
  }

  return {
    x,
    y,
  };
};
